import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ComputedRef, computed } from "vue";
import { useStore } from "vuex";
import TwLabel from "../TwLabel.vue";
import TwButtonsYesAndNo from "../TwButtonsYesAndNo.vue";


export default /*#__PURE__*/_defineComponent({
  __name: '10.ExperienceSkinBreakouts',
  setup(__props) {

const store = useStore();

const experienceSkinBreakouts: ComputedRef<boolean> = computed(
  () => store.state.form.experience_skin_breakouts
);
const updateExperienceSkinBreakouts = (value: boolean) => {
  store.dispatch("updateExperienceSkinBreakouts", value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[experienceSkinBreakouts.value == null ? 'bg-red-500' : ''], "p-2"])
  }, [
    _createVNode(TwLabel, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("experience_skin_breakouts")), 1)
      ]),
      _: 1
    }),
    _createVNode(TwButtonsYesAndNo, {
      isActive: experienceSkinBreakouts.value,
      onOnClickYes: _cache[0] || (_cache[0] = ($event: any) => (updateExperienceSkinBreakouts(true))),
      onOnClickNo: _cache[1] || (_cache[1] = ($event: any) => (updateExperienceSkinBreakouts(false)))
    }, null, 8, ["isActive"])
  ], 2))
}
}

})